import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import * as yaml from 'js-yaml';
import Button from './Button';
import React, { useEffect } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { getText, getPath, getReporterName } from '../common/utils/helpers';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string';
import { fetchData } from '../common/app/actions';
import CircularProgress from '@mui/material/CircularProgress';
import SurveysList from './SurveysList';
import ContentLayout from './ContentLayout';

const urlPrefix = getPath();

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      searchResultsContainerStyle: {
        // position: 'relative',
        // width: '100%',
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
        flex: 1,
      },
    })
);

const SearchResults = (): JSX.Element => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lng = useSelector((state: any) => state.app.lng);
  const searchData = useSelector((state: any) => state.app.searchData);
  const themesData = useSelector((state: any) => state.app.themesData);
  const { search, pathname } = useLocation();

  const { input } = queryString.parse(search);

  useEffect(() => {
    dispatch(fetchData(C.SEARCH_DATA, { input }));
    dispatch(fetchData(C.THEMES_DATA, { themes: true }));
  }, [input]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!searchData || !themesData) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  const getSubThemesData = () => {
    const subThemes = [];

    themesData.forEach((item) => {
      // console.log('>>>>', item);
      if (item?.pages?.length) {
        subThemes.push(...item?.pages);
      }
    });

    return subThemes;
  };

  const subThemeData = getSubThemesData();

  const getSanitizedSearchData = () => {
    return searchData.map((item) => {
      const { themeid, surveyid } = item.content;

      const themeData = themesData.find(
        (theme) => theme.content.uid === themeid
      );
      const themeName: string = getText(themeData?.content, 'title', lng);

      const surveyData = subThemeData.find(
        (theme) => theme.content.uid === surveyid
      );
      const surveyName: string = getText(surveyData?.content, 'title', lng);

      const image =
        item?.images?.[0] || surveyData?.images?.[0] || themeData?.images?.[0];
      const images = [image];

      const content = {
        ...item.content,
        themetitle: themeName,
        surveytitle: surveyName,
      };

      return {
        content,
        images,
      };
    });
  };

  const sanitizedSearchData = getSanitizedSearchData();

  return (
    <div className={classes.searchResultsContainerStyle}>
      <ContentLayout>
        <SurveysList data={sanitizedSearchData} showTheme />
      </ContentLayout>
    </div>
  );
};

export default SearchResults;
